import { Slide } from '@llx/common';

import { SlideStatsFieldsFragment } from '@/@generated/codegen/API';
import { captureSentry } from '@/utils/helpers/sentryHelper';

export type ParsedSlideStats = {
  id: string;
  index: number;
  title: string;
  time: number;
};

export type ParsedSlideStatsPerCase = Record<string, ParsedSlideStats[]>;

export function parseSlideStatsPerCase(
  cases: string[],
  slideList: Record<string, Slide[]>,
  slideStatsPerCase: Record<string, SlideStatsFieldsFragment[]>
) {
  const parsedSlideStatsPerCase: Record<string, ParsedSlideStats[]> = {};
  for (const c of cases) {
    if (!slideStatsPerCase[c] || slideStatsPerCase[c].length === 0) {
      parsedSlideStatsPerCase[c] = [];
      continue;
    }
    const slideStats = slideStatsPerCase[c].map((item) => {
      const slideInfo = slideList[c].find((slide) => slide.id === item.slideId);

      if (slideInfo) {
        return {
          id: slideInfo.id,
          index: slideList[c].indexOf(slideInfo),
          time: item.time,
          title: slideInfo.title,
        };
      }
      //this means it's statistics about an old slide that got deleted
      //NOTE: This is not an error
      captureSentry({
        title: 'parseSlideStatsPerCase: Slide not found, it is probably a deleted slide',
        detail: {
          slideId: item.slideId,
          caseId: c,
          cases: cases,
        },
      });
      return {
        id: '0',
        index: 0,
        time: item.time,
        title: item.slideId,
      };
    });
    slideStats.sort((a, b) => b.time - a.time);
    parsedSlideStatsPerCase[c] = slideStats;
  }

  return parsedSlideStatsPerCase;
}
